import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";

export const VolumeCorrectionConversionMethod = {
	DENSITY_CORRECTION_FACTOR: "Density Correction Factor (Chemical)",
	ASTM_TABLE_54_A: "ASTM table 54A (Crude Oil)",
	ASTM_TABLE_54_B: "ASTM table 54B (Refined product)",
	ASTM_TABLE_54_D: "ASTM table 54D (Lubricating Oil)",
};

export const ProductVolumeCorrectionConversionMethod = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		multiple={false}
		fetchOptions={Object.keys(VolumeCorrectionConversionMethod)}
		getOptionLabel={opt => VolumeCorrectionConversionMethod[opt as keyof typeof VolumeCorrectionConversionMethod]}
		value={value}
		onChange={onChange}
	/>;
};

// eslint-disable-next-line react-refresh/only-export-components
export function productVolumeCorrectionConversionMethodField(method: string | undefined | null) {
	if (!method) {
		return "-";
	}
	return VolumeCorrectionConversionMethod[method as keyof typeof VolumeCorrectionConversionMethod] || method;
}
